module.exports = __webpack_public_path__ + "img/loading.0ae26e55.gif";